import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import VisibilitySensor from 'react-visibility-sensor'
import ReactPlayer from 'react-player'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import PjmGlance from "../components/pjm-glance"
import useWindowSize from "../hooks/useWindowDimensions"
import arrowLeft from "../images/yellow-arrow.svg"
import VideoSrc from "../videos/Sprint1_Welcome_3Pillars_DESKTOP.mp4"
import VideoSrcMobile from "../videos/Sprint1_Welcome_3Pillars_MOBILE.mp4"
import chevronDown from "../images/angle-down.svg"
import nextImage from "../images/double-profile.jpg"
import prevImage from "../images/Hero_08_Innovation.jpg"
import financials2021 from "../images/PJM_2021_Financials.pdf"
import nextRings from "../images/RINGS_MAGENTA_YELLOW.svg"
import prevRings from "../images/RINGS_CYAN_YELLOW.svg"
import downloadIcon from "../images/download.svg"
import culGraph from "../images/cul-graph.svg"
import culArrow from "../images/cul-arrow.svg"
import culGlass from "../images/cul-glass.svg"
import { Link } from "gatsby"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"


import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const CulturePage = (props) => {
    const size = useWindowSize();
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);
    const secondBubble1 = useRef();
    const secondBubble2 = useRef();
    const secondBubble3 = useRef();

    useLayoutEffect(() => {
        console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(firstRow.current, { y: 200, ease: "power2"});
        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function onChangeSecondBubble(isVisible) {
        let tl = gsap.timeline({paused: true})
        .fromTo(secondBubble1.current, {opacity: 0, x: -100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.5")
        .fromTo(secondBubble2.current, {opacity: 0, x: 0, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(secondBubble3.current, {opacity: 0, x: 100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")

        if(isVisible) {
            tl.play(0);
        }
    }

    return (
        <Layout>
            <main className="page caring">
                <title>Culture of Caring Page</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 9 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="culture-of-caring" className="text--yellow">Culture of Caring</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile" data-scroll data-scroll-speed="0">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_10_Culture.jpg" alt="" />
                                        <img className="rings" src={ringsbm} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div data-scroll data-scroll-speed="3" className="title--super text--outline">SUPPORTING OUR
                                    </div>
                                        <h1 data-scroll data-scroll-speed="2">WORKFORCE</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                            >
                                                Read Lorem
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div
                                    ref={(element) => circles.current[0] = element} 
                                    className="circle--green top p-7"
                                    data-speed=".2"
                                ></div>
                                <div
                                    ref={(element) => circles.current[1] = element} 
                                    className="circle--pink top p-7"
                                    data-speed="-.2"
                                ></div>
                                <div
                                    ref={(element) => circles.current[2] = element} 
                                    className="circle--yellow top p-7"
                                    data-speed=".2"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Diversity, Equity & Inclusion</h5>
                        <h6 className="text--uppercase">Chief Diversity, Equity & Inclusion Officer</h6>
                        <p className="text">PJM appointed Michael Coyle, who brings 20 years of experience, to a new role as chief diversity, equity & inclusion officer.</p>
                        <p className="text">To increase awareness and support of diversity, equity and inclusion, Coyle has developed and led a framework where everyone has a role to play through listening, storytelling, allyship and collaborative development at PJM.</p>
                    </div>
                </div>
                <div className="sec-pad">
                    <div className="row row-wrapper row-reverse-desktop content">
                        <div className="col-xs-12 col-md-5">
                            <div className="profile-wrap">
                                <div className="profile">
                                    <StaticImage loading="lazy" placeholder="blurred" quality="50" objectFit="contain" className="avatar" src="../images/Quote_10_Culture.jpg" alt=""/>
                                    <img className="rings" src={ringsbm} alt="" /> 
                                </div>
                            </div>
                       </div>
                        <div className="col-xs-12 col-md-7">
                             <blockquote>
                                 <p className="text--blue">“It’s important to cultivate an environment that is inclusive, where everyone can feel a sense of belonging and has a safe space to share their journey. PJM is fostering a workplace that reflects the diversity of the people we serve.”</p>
                             </blockquote>
                             <div className="text--author text--uppercase text--blue"> — Michael Coyle, Chief Diversity, Equity & Inclusion Officer</div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <p className="text">PJM supported a variety of events and activities aimed at helping employees connect and foster a diverse and inclusive workplace:</p>
                        <ul>
                          <li>In honor of Black History Month, PJM held a speaker series event with MK Palmore, a distinguished leader in the areas of cybersecurity, crisis management/response, domestic and international terrorism, public corruption, hate crimes and violent crimes.</li>
                          <li>Women’s History Month was celebrated with a virtual tour of the Museum of the American Revolution’s exhibit: “When Women Lost the Vote.”</li>
                          <li>Lambda, PJM’s LGBTQIA+ employee resource group, held a Parents & Family panel to share thoughts, experiences and resources.</li>
                          <li>National Disability Employment Awareness Month was recognized in October.</li>
                          <li>Hispanic Heritage Month was recognized with a “Sharing Our Stories” event.</li>
                          <li>Lambda and the Asian American employee resource group co-hosted an event to promote allyship.</li>
                        </ul>
                    </div>
                </div>
                <div className="sec-pad">
                    <div className="row row-wrapper row-reverse-desktop content align-center">
                        <div className="col-xs-12 col-md-7">
                            <h2>Top Adoption-Friendly Workplace</h2>
                            <p>In 2021, PJM achieved milestone status as it was named among the top 100 adoption-friendly companies in the U.S. for the 15th year in the row. This honor was bestowed by the Dave Thomas Foundation for Adoption. PJM also ranked first in the category among energy and utility companies.</p>
                            <p>PJM has been offering substantial financial assistance for adoption-related expenses incurred by full-time employees since 2006. PJM’s policy reimburses families for many types of expenses related to adopting a child, including fees, travel and legal costs.</p>
                        </div>
                        <div className="col-xs-12 col-md-5">
                            <div className="profile-wrap mobile-margin-top">
                                <div className="">
                                    <StaticImage loading="lazy" placeholder="blurred" quality="80" objectFit="contain" className="avatar" src="../images/AFW_100Best-2021.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Employees Support Local Communities</h5>
                        <p className="text">PJM’s employees have a strong tradition of giving back to our communities by helping improve the lives of those around us. Although the COVID-19 pandemic limited our ability to engage in face-to-face volunteer activities, employees continued to find ways to support underserved communities through personal donations and awareness activities.</p>
                        <p className="text">Employees and Board members contributed $35,607 to our Fall Giving Campaign to support the Norristown Hospitality Center, Philabundance and the United Way of Greater Philadelphia & Southern New Jersey. The company is looking forward to resuming in-person volunteer events in 2022.</p>
                    </div>
                </div>  
                <div className="bg-blue bg-color sec-pad">
                    <div className="row row-wrapper">
                        <div className="col-xs-12">
                            <h5 className="text--uppercase text--yellow m-b-20">PJM Recognizes Major Milestone for Human Performance & Operating Experience Program</h5>
                            <p className="text text--white">Addressing the “human factor” is a critical element of successful PJM strategies to support reliable grid operations, fair and efficient markets, and infrastructure planning.</p>
                            <p className="text text--white">In 2021, PJM reached the milestone of 950 completed action items associated with the Human Performance & Operating Experience Program.</p>
                            <p className="text text--white m-b-30">The program focuses on continuous improvement:</p>
                        </div>
                    </div>
                    <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeSecondBubble}>
                        <div className="row row-wrapper content">
                            <div className="col-xs-12 p-b-40">
                                <div className="bubble-wrap">
                                    <div ref={secondBubble1} className="bubble circle--blue">
                                        <div className="info">
                                            <div className="icon--large">
                                                <img src={culGraph} alt=""/>
                                            </div>
                                            <div className="bubble-title">
                                                Reducing or preventing human errors
                                            </div>
                                        </div>
                                    </div>
                                    <div ref={secondBubble2} className="bubble circle--green">
                                        <div className="info">
                                            <div className="icon--large">
                                                <img src={culArrow} alt=""/>
                                            </div>
                                            <div className="bubble-title">
                                                Becoming organizationally resilient to errors
                                            </div>
                                        </div>
                                    </div>
                                    <div ref={secondBubble3} className="bubble circle--yellow">
                                        <div className="info">
                                            <div className="icon--large">
                                                <img src={culGlass} alt=""/>
                                            </div>
                                            <div className="bubble-title">
                                                 Analyzing and learning from events
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </VisibilitySensor>
                    <div className="row row-wrapper">
                        <div className="col-xs-12">
                            <p className="text--large text--white">As a result, corrective action items have been implemented resulting from “Good Catches” and “Event Analysis.” These include process improvements and updates to procedures, operation protocols, training, communications, technical solutions and tools.</p>
                        </div>
                    </div>
                </div>
                <div class="row row-wrapper content">
                    <div class="col-xs-12">
                        <div class="bg-blue p-t-60 p-b-60 download-container">
                            <a onClick={()=> window.open(financials2021, "_blank")}>
                                <div className="download-wrap">
                                    <a className="download">
                                        <div className="icon">
                                            <img src={downloadIcon} alt=""/>
                                        </div> 
                                    </a>
                                </div>
                                <p className="text text--center text--white text--bold quote-text">View/Download the PJM 2021 Financial Report</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    ref={(element) => circles.current[3] = element} 
                    className="circle--blue page-1"
                    data-speed=".2"
                ></div>
            </main>
            <Footer 
                nextLink="" 
                nextImage=""
                nextText=""
                nextTitle=""
                nextButton="" 
                nextRings=""
                prevLink="/innovation" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton=""
                prevTitle="Innovation"  
                prevRings={prevRings}
            />
        </Layout>
    )
}

export default CulturePage
